module.exports = __webpack_public_path__ + "static/media/160.b1927eb6.jpg";